import { emojiFromEmotion } from '../../../../components/DeviceScreenPreview'
import { EMOTION_LABELS, normalizeEmotion } from '../../../../utils/emotion'
import { CHAMII_PRIMARY_VARIANTS, OSS_GROUP_LABELS, OSS_PROJECTS_RAW, THEMES } from './eyesPreviewCatalog'

export const DEFAULT_VARIANT_BY_THEME = {
  robo: '',
  chamii: 'macaron',
  miaoban: '',
  raw: '',
  classic: '',
  oled: 'ir_basic',
  ani: '',
  esp32: '',
  uncanny: 'adafruit',
  round: 'round240',
}

export function normalizeOssProject(p) {
  if (!p || typeof p !== 'object') return p
  const theme = String(p.theme || '')
  const variantRaw = p.variant == null ? '' : String(p.variant)
  const variant = (() => {
    if (theme === 'oled') {
      const v = variantRaw
      if (['robot_eyes', 'robotic_eye', 'oled_robot_eye', 'robot_eyes_oled'].includes(v)) return 'robot_eyes_oled'
      return v
    }
    return variantRaw
  })()
  return { ...p, theme, variant }
}

export const OSS_PROJECTS = OSS_PROJECTS_RAW.map(normalizeOssProject)

export const EMOTIONS = Object.keys(EMOTION_LABELS)

export const LIBRARY_MOODS = [
  'neutral',
  'happy',
  'laughing',
  'loving',
  'winking',
  'thinking',
  'confused',
  'surprised',
  'angry',
  'sad',
  'sleepy',
  'cool',
  'relaxed',
  'silly',
  'confident',
  'delicious',
]

export const ACCENT_PRESETS = [
  { id: 'pink', label: 'Pink', value: '#FF5C5C' },
  { id: 'yellow', label: 'Yellow', value: '#FFD233' },
  { id: 'cyan', label: 'Cyan', value: '#40E0D0' },
  { id: 'orange', label: 'Orange', value: '#FB923C' },
  { id: 'purple', label: 'Purple', value: '#A855F7' },
  { id: 'green', label: 'Green', value: '#22C55E' },
  { id: 'ink', label: 'Ink', value: '#111827' },
]

export const ANI_MOOD_CARDS = [
  { id: 'Happy', emoji: '🙂', subtitle: 'Ani mood · 3 frames', emotion: 'happy' },
  { id: 'Neutral', emoji: '😶', subtitle: 'Ani mood · 3 frames', emotion: 'neutral' },
  { id: 'Sleep', emoji: '😴', subtitle: 'Ani mood · 3 frames', emotion: 'sleepy' },
  { id: 'Angry', emoji: '😠', subtitle: 'Ani mood · 3 frames', emotion: 'angry' },
  { id: 'Upset', emoji: '🙄', subtitle: 'Ani mood · 3 frames', emotion: 'confused' },
  { id: 'Sad', emoji: '😢', subtitle: 'Ani mood · 3 frames', emotion: 'sad' },
  { id: 'Love', emoji: '😍', subtitle: 'Ani mood · 3 frames', emotion: 'loving' },
]

export const ESP32_EXPRESSION_CARDS = [
  { id: 'Normal', emoji: '😶', subtitle: 'Preset_Normal', expression: 'Normal' },
  { id: 'Happy', emoji: '🙂', subtitle: 'Preset_Happy', expression: 'Happy' },
  { id: 'Glee', emoji: '😄', subtitle: 'Preset_Glee', expression: 'Glee' },
  { id: 'Awe', emoji: '😲', subtitle: 'Preset_Awe', expression: 'Awe' },
  { id: 'Surprised', emoji: '😮', subtitle: 'Preset_Surprised', expression: 'Surprised' },
  { id: 'Scared', emoji: '😱', subtitle: 'Preset_Scared', expression: 'Scared' },
  { id: 'Angry', emoji: '😠', subtitle: 'Preset_Angry', expression: 'Angry' },
  { id: 'Furious', emoji: '🤬', subtitle: 'Preset_Furious', expression: 'Furious' },
  { id: 'Sad', emoji: '😢', subtitle: 'Preset_Sad', expression: 'Sad' },
  { id: 'Worried', emoji: '😟', subtitle: 'Preset_Worried_Alt / Preset_Worried', expression: 'Worried' },
  { id: 'Sleepy', emoji: '😴', subtitle: 'Preset_Sleepy_Alt / Preset_Sleepy', expression: 'Sleepy' },
  { id: 'Focused', emoji: '🧐', subtitle: 'Preset_Focused', expression: 'Focused' },
  { id: 'Skeptic', emoji: '😏', subtitle: 'Preset_Skeptic_Alt / Preset_Skeptic', expression: 'Skeptic' },
  { id: 'Suspicious', emoji: '🤨', subtitle: 'Preset_Suspicious_Alt / Preset_Suspicious', expression: 'Suspicious' },
  { id: 'Unimpressed', emoji: '😑', subtitle: 'Preset_Unimpressed_Alt / Preset_Unimpressed', expression: 'Unimpressed' },
  { id: 'Annoyed', emoji: '😒', subtitle: 'Preset_Annoyed_Alt / Preset_Annoyed', expression: 'Annoyed' },
  { id: 'Frustrated', emoji: '😣', subtitle: 'Preset_Frustrated', expression: 'Frustrated' },
  { id: 'Squint', emoji: '😆', subtitle: 'Preset_Squint_Alt / Preset_Squint', expression: 'Squint' },
]

export const MIAOBAN_MOOD_CARDS = [
  { id: 'Neutral', emoji: '😶', subtitle: 'EAF · neutral', emotion: 'neutral' },
  { id: 'Happy', emoji: '🙂', subtitle: 'EAF · Happy', emotion: 'happy' },
  { id: 'Sad', emoji: '😔', subtitle: 'EAF · Sad', emotion: 'sad' },
  { id: 'Angry', emoji: '😠', subtitle: 'EAF · angry', emotion: 'angry' },
  { id: 'Confused', emoji: '🙄', subtitle: 'EAF · confused', emotion: 'confused' },
  { id: 'Surprised', emoji: '😱', subtitle: 'EAF · shocked', emotion: 'surprised' },
  { id: 'Sleepy', emoji: '😴', subtitle: 'EAF · sleep', emotion: 'sleepy' },
  { id: 'Wink', emoji: '😉', subtitle: 'EAF · winking', emotion: 'winking' },
]

export function roboGroupKey(emotion) {
  const e = normalizeEmotion(emotion)
  const confused = ['confused', 'thinking', 'surprised', 'embarrassed'].includes(e)
  const laugh = e === 'laughing'
  const wink = e === 'winking'

  if (confused) return 'confused'
  if (laugh) return 'laugh'
  if (wink) return 'wink'

  if (['happy', 'loving', 'cool', 'relaxed', 'confident', 'delicious', 'silly'].includes(e)) return 'happy'
  if (e === 'angry') return 'angry'
  if (['sleepy', 'sleep', 'tired', 'sad'].includes(e)) return 'tired'
  return 'default'
}

export function roboCardForKey(key) {
  switch (key) {
    case 'happy':
      return { id: 'happy', label: { zh: 'Happy（mood）', en: 'Happy (mood)' }, emoji: emojiFromEmotion('happy'), subtitle: 'RoboEyes mood', emotion: 'happy' }
    case 'angry':
      return { id: 'angry', label: { zh: 'Angry（mood）', en: 'Angry (mood)' }, emoji: emojiFromEmotion('angry'), subtitle: 'RoboEyes mood', emotion: 'angry' }
    case 'tired':
      return { id: 'tired', label: { zh: 'Tired（mood）', en: 'Tired (mood)' }, emoji: emojiFromEmotion('sleepy'), subtitle: 'RoboEyes mood', emotion: 'sleepy' }
    case 'confused':
      return { id: 'confused', label: { zh: 'Confused（anim）', en: 'Confused (anim)' }, emoji: emojiFromEmotion('confused'), subtitle: 'RoboEyes flicker', emotion: 'confused' }
    case 'laugh':
      return { id: 'laugh', label: { zh: 'Laugh（anim）', en: 'Laugh (anim)' }, emoji: emojiFromEmotion('laughing'), subtitle: 'RoboEyes flicker', emotion: 'laughing' }
    case 'wink':
      return { id: 'wink', label: { zh: 'Wink（anim）', en: 'Wink (anim)' }, emoji: emojiFromEmotion('winking'), subtitle: 'RoboEyes wink', emotion: 'winking' }
    case 'default':
    default:
      return { id: 'default', label: { zh: 'Default（mood）', en: 'Default (mood)' }, emoji: emojiFromEmotion('neutral'), subtitle: 'RoboEyes mood', emotion: 'neutral' }
  }
}

export function repoNameFromUrl(url) {
  if (!url) return ''
  try {
    const u = new URL(String(url))
    const parts = u.pathname.split('/').filter(Boolean)
    return parts[parts.length - 1] || ''
  } catch {
    const parts = String(url).split('/').filter(Boolean)
    return parts[parts.length - 1] || String(url)
  }
}

export function shortenTag(text, maxLen = 18) {
  const s = String(text || '')
  if (s.length <= maxLen) return s
  return `${s.slice(0, Math.max(1, maxLen - 1))}…`
}

export function summarizeList(list, max = 6) {
  const arr = Array.isArray(list) ? list.filter(Boolean) : []
  if (arr.length <= max) return arr.join(', ')
  const head = arr.slice(0, max).join(', ')
  return `${head} … (+${arr.length - max})`
}

export function clamp01(v) {
  return Math.max(0, Math.min(1, v))
}

export function groupOssProjects(projects, themes) {
  const themeOrder = new Map((themes || []).map((t, i) => [t.id, i]))
  const map = new Map()
  for (const p of projects || []) {
    const theme = p?.theme || ''
    const variant = p?.variant || ''
    const key = `${theme}::${variant}`
    if (!map.has(key)) map.set(key, { theme, variant, projects: [] })
    map.get(key).projects.push(p)
  }

  const chamiiVariantOrder = new Map(CHAMII_PRIMARY_VARIANTS.map((v, i) => [v, i]))

  const groups = Array.from(map.values())
  groups.sort((a, b) => {
    const ao = themeOrder.has(a.theme) ? themeOrder.get(a.theme) : 999
    const bo = themeOrder.has(b.theme) ? themeOrder.get(b.theme) : 999
    if (ao !== bo) return ao - bo

    if (a.theme === 'chamii' && b.theme === 'chamii') {
      const av = String(a.variant || '')
      const bv = String(b.variant || '')
      const aw = chamiiVariantOrder.has(av) ? chamiiVariantOrder.get(av) : 999
      const bw = chamiiVariantOrder.has(bv) ? chamiiVariantOrder.get(bv) : 999
      if (aw !== bw) return aw - bw
    }

    const ak = `${a.theme}::${a.variant || ''}`
    const bk = `${b.theme}::${b.variant || ''}`
    const at = OSS_GROUP_LABELS[ak] || a.projects?.find((p) => p.tag)?.tag || repoNameFromUrl(a.projects?.[0]?.repo) || a.projects?.[0]?.label || ''
    const bt = OSS_GROUP_LABELS[bk] || b.projects?.find((p) => p.tag)?.tag || repoNameFromUrl(b.projects?.[0]?.repo) || b.projects?.[0]?.label || ''
    return String(at).localeCompare(String(bt))
  })
  return groups.map((g) => {
    const key = `${g.theme}::${g.variant || ''}`
    return { ...g, label: OSS_GROUP_LABELS[key] || '' }
  })
}

export function ossGroupKey(g) {
  if (!g) return ''
  return `${g.theme || ''}::${g.variant || ''}`
}

export function ossGroupDisplayName(g) {
  const primary = g?.projects?.find((p) => p?.tag) || g?.projects?.[0]
  return (
    g?.label ||
    primary?.tag ||
    repoNameFromUrl(primary?.repo) ||
    primary?.label ||
    (g?.theme ? (g?.variant ? `${g.theme}:${g.variant}` : g.theme) : '')
  )
}

export function libraryFamilyKey(g) {
  const theme = String(g?.theme || '')
  const variant = String(g?.variant || '')

  if (theme === 'oled') {
    return 'oled::family'
  }

  if (theme === 'chamii') {
    return 'chamii::family'
  }

  if (theme === 'esp32') {
    const all = new Set(['', 'tft_espi', 'lcd'])
    if (all.has(variant)) return 'esp32::family'
  }

  if (theme === 'uncanny') {
    return 'uncanny::family'
  }

  return `${theme}::${variant}`
}

export const LIBRARY_FAMILY_LABELS = {
  'oled::family': { zh: 'OLED（合集）', en: 'OLED (Collection)' },
  'chamii::family': { zh: 'Chamii Cute（合集）', en: 'Chamii Cute (Collection)' },
  'esp32::family': { zh: 'esp32‑eyes（合集）', en: 'esp32‑eyes (Collection)' },
  'uncanny::family': { zh: 'UncannyEyes（合集）', en: 'UncannyEyes (Collection)' },
}

